import { render, staticRenderFns } from "./DdSubHeaderWithSwitch.vue?vue&type=template&id=a38cba8c&scoped=true&"
import script from "./DdSubHeaderWithSwitch.vue?vue&type=script&lang=js&"
export * from "./DdSubHeaderWithSwitch.vue?vue&type=script&lang=js&"
import style0 from "./DdSubHeaderWithSwitch.vue?vue&type=style&index=0&id=a38cba8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38cba8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
